import { render, staticRenderFns } from "./decorateRectify.vue?vue&type=template&id=bb8dc1be&scoped=true&"
import script from "./decorateRectify.vue?vue&type=script&lang=js&"
export * from "./decorateRectify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8dc1be",
  null
  
)

export default component.exports